import * as React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

export interface GlyphIconProps {
  icon?: string
  statusDotColor?: string
  iconColor?: string
  backgroundColor?: string
  className?: string
  children?: React.ReactNode
}

const GlyphIcon = React.forwardRef<React.Ref<any>, GlyphIconProps>(
  (
    {
      icon,
      statusDotColor,
      backgroundColor = theme.colors.steel[2],
      iconColor = theme.colors.gray[1],
      children,
      ...rest
    }: GlyphIconProps,
    ref: React.Ref<any>
  ) => (
    <div
      ref={ref}
      css={{
        height: 40,
        width: 40,
        position: 'relative'
      }}
      {...rest}
    >
      <div
        className="glyph-circle"
        css={{
          backgroundColor: backgroundColor,
          borderRadius: theme.borderRadius[2],
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex'
        }}
      >
        {children ? (
          children
        ) : (
          <Icon
            css={{
              display: 'flex',
              verticalAlign: 'middle',
              fontSize: theme.fontSizes[4],
              position: 'relative',
              color: iconColor
            }}
            icon={icon}
          />
        )}
      </div>
      {statusDotColor && (
        <div
          css={{
            position: 'absolute',
            backgroundColor: statusDotColor,
            border: 'solid 2px white',
            borderRadius: '100%',
            boxSizing: 'content-box',
            height: theme.space[2],
            width: theme.space[2],
            minWidth: theme.space[2],
            left: 28,
            top: 28,
            zIndex: 0
          }}
        />
      )}
    </div>
  )
)

export default GlyphIcon

export const HeptagonGlyphIcon: React.FC<GlyphIconProps> = props => (
  <GlyphIcon
    css={{
      '& .glyph-circle': {
        paddingTop: 2,
        clipPath:
          'polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%)',
        borderRadius: 0 // reset border radius for
      }
    }}
    {...props}
  />
)
